window.addEventListener('load', function () {
    runCarousel();
});

document.addEventListener("shopify:section:load", function(event) {
    runCarousel();
});

function runCarousel() {
    const carouselElements = this.document.querySelectorAll('.carousel');
    if (carouselElements) {
        carouselElements.forEach(element => {
            const buttonNext = element.parentElement.querySelector('.swiper-button-next')
            const buttonPrev = element.parentElement.querySelector('.swiper-button-prev')
            const swiper = new Swiper(element, {
                // Optional parameters
                slidesPerView: 'auto',
                loop: true,
                spaceBetween: 0,
                watchSlides: true,

                // If we need pagination
                pagination: {
                    el: '.swiper-pagination',
                },

                // Navigation arrows
                navigation: {
                    nextEl: buttonNext,
                    prevEl: buttonPrev,
                },
            });
        });
    }
}